module.exports = __webpack_public_path__ + "img/trip-cancelation.cde5811a.jpg";